import http from './http'

export function getLoggedInUser() {
  return http.get("/v1/profile/me", { withCredentials: true })
}

export function getHandbook() {
  return http.get("/v1/handbooks", { withCredentials: true})
}

export function createHandbook(handbook) {
  return http.post("/v1/handbooks", handbook, { withCredentials: true})
}

export function updateHandbook(handbook) {
  return http.put(`/v1/handbooks/${handbook.handbook.id}`, handbook, { withCredentials: true})
}

export function uploadImage(property, file) {
  var formData = new FormData()
  formData.append('upload', file)
  formData.append('property', property)
  return http.post("/v1/handbooks/upload/image", formData, { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true})
}

export function getSections(handbook_id) {
  return http.get(`/v1/handbooks/${handbook_id}/sections`, { withCredentials: true })
}

export function createSection(handbook_id, section) {
  return http.post(`/v1/handbooks/${handbook_id}/sections`, {section}, { withCredentials: true })
}

export function updateSection(handbook_id, section) {
  return http.put(`/v1/handbooks/${handbook_id}/sections/${section.id}`, {section}, { withCredentials: true })
}

export function deleteSection(handbook_id, section) {
  return http.delete(`/v1/handbooks/${handbook_id}/sections/${section.id}`, { withCredentials: true })
}

export function visited(handbook) {
  return http.post(`/v1/handbooks/${handbook.handbook.id}/visited`, {withCredentials: true})
}

export function signed(handbook, name) {
  return http.post(`/v1/handbooks/${handbook.handbook.id}/signed`, {'name': name }, {withCredentials: true})
}
